import { render, staticRenderFns } from "./OurDifference.vue?vue&type=template&id=22768511&"
import script from "./OurDifference.vue?vue&type=script&lang=js&"
export * from "./OurDifference.vue?vue&type=script&lang=js&"
import style0 from "./OurDifference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports